import DesignerInfoContainer from "./DesignerInfoContainer";
export default DesignerInfoContainer;
